// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"df6e69a3","977":"d052920a"}[chunkId] + ".chunk.js";
};